export default __webpack_public_path__ + "static/media/brocoli.ea8b7b49.png";